import { Autocomplete, Box, Button, Divider, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const warehouses = [
  { description: '8AAA' },
  { description: '8AAB' },
  { description: '8AAC' },
  { description: '8AAE' },
  { description: '8AAG' },
];

const BinForm = ({ action, actionText, buttonText, ...props }) => {
  const [description, setDescription] = useState(
    props.bin ? props.bin.binName : '',
  );
  const [warehouse, setWarehouse] = useState(
    props.bin ? props.bin.warehouse : '',
  );
  const user = useSelector((state) => state.user);
  const { t } = useTranslation();
  const handleSubmit = () => {
    action({ description, warehouse });
    setDescription('');
  };

  return (
    <Box sx={{ width: '100%' }}>
      <h1>{`${actionText}`} </h1>
      <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: { xs: 'flex', md: 'flex' },
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: { xs: 'center', md: 'space-evenly' },
        }}
      >
        <TextField
          sx={{
            xs: { display: 'block', width: '100%' },
            md: { display: 'flex' },
            width: '70%',
          }}
          variant="standard"
          label={t('brand.descriptionField')}
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        {user.users.role === 'ADMIN' && (
          <Autocomplete
            disablePortal
            id="combo-warehouses"
            options={warehouses.map((el) => ({
              label: el.description,
            }))}
            sx={{ width: '20%', ml: 1 }}
            value={warehouse}
            onChange={(e, value) => setWarehouse(value ? value.label : '')}
            renderInput={(params) => (
              <TextField
                variant="standard"
                required
                {...params}
                label={t('pz05.report.warehouse')}
              />
            )}
          />
        )}
        <Button
          sx={{
            bgcolor: '#C09A53',
            color: 'white',
            ':hover': { bgcolor: '#9c7c43' },
            width: '150px',
            height: '50px',
            mt: { xs: 3, md: 0 },
          }}
          onClick={handleSubmit}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default BinForm;
